import {ContentLikeVerboseDomain} from "../../domain/content/ContentLikeVerboseDomain"
import {ContentId} from "../../id/content/ContentId"
import {ContentLikeId} from "../../id/content/ContentLikeId"
import {UserId} from "../../id/user/UserId"
import {UserValueObject} from "../user/UserValueObject"
import {ContentValueObject} from "./ContentValueObject"
import {VerboseValueObject} from "ts-protocol-extension"

/**
 * 콘텐츠 좋아요 상세
 */
export class ContentLikeVerboseValueObject implements VerboseValueObject, ContentLikeVerboseDomain {
    /**
     * 기본키
     */
    id: ContentLikeId
    /**
     * 콘텐츠 ID
     */
    contentId: ContentId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 콘텐츠 ID
     */
    content: ContentValueObject
    /**
     * 사용자 ID
     */
    user: UserValueObject

    constructor(o: Record<keyof ContentLikeVerboseDomain, any>) {
        this.id = BigInt(o.id)
        this.contentId = BigInt(o.contentId)
        this.userId = BigInt(o.userId)
        this.createdAt = new Date(o.createdAt)
        this.content = new ContentValueObject(o.content)
        this.user = new UserValueObject(o.user)
    }
}
